import React, { useCallback, useMemo } from "react";
import { twMerge } from "tailwind-merge";

import { SupText as Text } from "../../../components/UI/Text";

type Value = string | number;
type NormalizedValue = [label: string, value: Value];

interface AllocationProps {
  className?: string;
  values: (Value | NormalizedValue)[];
  onClick?: (value: Value) => void;
}

export function SupAllocation({ className, values, onClick }: AllocationProps) {
  const normalizedValues = useMemo(() => values.map(v => (Array.isArray(v) ? v : ([typeof v === "string" ? v : v.toString(), v] as NormalizedValue))), [values]);
  const handleClick = useCallback(
    (value: Value) => () => {
      onClick?.(value);
    },
    [onClick]
  );

  return (
    <div className={twMerge("sup-allocation inline-flex gap-2.5", className)}>
      {normalizedValues.map(([label, value]) => {
        return (
          <Text
            as="span"
            key={value}
            variant="caption"
            onClick={handleClick(value)}
            tabIndex={0}
            className="inline-flex items-center bg-neutral-600 hover:bg-neutral-700 text-neutral-50 px-1 h-4 cursor-pointer transition-colors duration-200"
          >
            {label}
          </Text>
        );
      })}
    </div>
  );
}
